module.exports = __webpack_public_path__ + "static/img/global_up_arrow@3x.6635201.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/global_up_arrow@3x.png
// module id = evzA
// module chunks = 1